"use client"

import React, {createContext, useContext, useState, useEffect} from "react"

type OrgContextType = {
    orgId: string
    setOrgId: (org: string) => void
    clearOrgId: () => void
};

const ORG_ID_STORAGE_KEY = "meersec-connect-org-id";

const OrgContext = createContext<OrgContextType | undefined>(undefined)

export function OrgProvider({ children }: { children: React.ReactNode }) {
    const [orgId, setOrgIdState] = useState<string>("")
    
    // Initialize from localStorage on mount
    useEffect(() => {
        if (typeof window !== "undefined") {
            const storedOrgId = localStorage.getItem(ORG_ID_STORAGE_KEY);
            if (storedOrgId) {
                setOrgIdState(storedOrgId);
            }
        }
    }, []);
    
    // Custom setter that also updates localStorage
    const setOrgId = (org: string) => {
        setOrgIdState(org);
        if (typeof window !== "undefined") {
            localStorage.setItem(ORG_ID_STORAGE_KEY, org);
        }
    };
    
    // Method to clear orgId (for logout)
    const clearOrgId = () => {
        setOrgIdState("");
        if (typeof window !== "undefined") {
            localStorage.removeItem(ORG_ID_STORAGE_KEY);
        }
    };

    return <OrgContext.Provider value={{ orgId, setOrgId, clearOrgId }}>
        {children}
    </OrgContext.Provider>
}

export function useOrg() {
    const ctx = useContext(OrgContext)
    if (!ctx) throw new Error("useOrg must be used within OrgProvider")
    return ctx
}